export default __webpack_public_path__ + "static/media/intro_new.8ec3ab61.png";